import { useFetchedValues } from "../../../../../Hooks/Display/useComponentProperties";
import usePages from "../../../../../Hooks/Display/usePages";
import { getPageByProperty } from "../../../utils";

function TargetCell({ dataItem, hidden }) {

    const [{ pages }] = usePages();
    const [{ actionTable: { attributes }}] = useFetchedValues();

    if (dataItem.actionType === "Navigate to External URL") {
        return (
            <td>
                <span className={hidden ? "text-muted" : ""}>
                    {dataItem.targetURL}
                </span>
            </td>
        );
    }
    if (dataItem.actionType === "Navigate to Attribute URL") {

        function getAttributeName() {
            const attribute = attributes.find((attribute) => attribute.id === dataItem.targetAttributeId);
            return attribute?.attributeName;
        }

        return (
            <td>
                {dataItem.targetAttributeId ? (
                    <span className={hidden ? "text-muted" : ""}>
                        { getAttributeName() }
                    </span>
                ) : (
                    <span className="text-danger">Select Attribute</span>
                )}
            </td>
        );
    }
    if (
        dataItem.actionType === "Navigate" ||
        dataItem.actionType === "New" ||
        dataItem.actionType === "Edit" ||
        (dataItem.actionType === "Link" &&
            dataItem.componentType === "Heading")
    ) {
        function getTargetPageName() {
            const targetPage = getPageByProperty(pages, "_id", dataItem.targetPageId);
            return targetPage?.pageName;
        }

        return (
            <td>
                {dataItem.targetPageId ? (
                    <span className={hidden ? "text-muted" : ""}
                    >
                        { getTargetPageName() }
                    </span>
                ) : (
                    <span className="text-danger">Select Page</span>
                )}
            </td>
        );
    }
    return (
        <td>
            <span className={hidden ? "text-muted" : ""}>
                N/A
            </span>
        </td>
    );
}

export default TargetCell;